import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { QuibblService } from '../../quibbl.service';
import { AuthService } from '../../auth.service';


@Component({
  selector: 'comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {

  @Input() quibbl: string;
  public commentsSubscription;
  public comments;
  public isSuperUser = false;
  public superUserSubscription;
  public URI;

  constructor(private _qb: QuibblService,
              private auth: AuthService) { }

  ngOnInit() {

  }

  ngOnDestroy() {
    if(this.commentsSubscription) this.commentsSubscription.unsubscribe();
    if(this.superUserSubscription) this.superUserSubscription.unsubscribe();
  }

  escapeHTML(escapeString: string) {
    return escapeString
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  ngOnChanges() {
    this.URI = require('urijs');
    let that = this;
    if(this.commentsSubscription) this.commentsSubscription.unsubscribe();
    this.commentsSubscription =
      this._qb.getCommentsForQuibbl(this.quibbl).subscribe(comments => {
        this.comments = [];
        for(let i=comments.length-1; i>=0; i--) {
          let comment = comments[i];
          let message = comments[i].message;
          //
          // message = message.replace(/&(lt|gt);/g, function (strMatch, p1) {
			    //      return (p1 == "lt")? "<" : ">";
		      // });
		      // message = message.replace(/<\/?[^>]+(>|$)/g, "");
          //
          // comment.message = this.URI.withinString(message, function(url) {
          //   var uri = new that._URI(url);
          //   if(!uri.protocol() || uri.protocol() == '') {
          //     uri.protocol('http')
          //   }
          //   return "<a href=\"" + that.escapeHTML(uri.toString()) + "\" target=\"_blank\">" + url + "</a>";
          // });
          this.comments.push(comment);
        }
      });

    if(this.superUserSubscription) this.superUserSubscription.unsubscribe();
    this.superUserSubscription = this.auth.userIsSuperUser.subscribe((superUser: boolean) => {
      this.isSuperUser = superUser;
    });
  }

  public deleteComment(comment) {
    this._qb.deleteComment(this.quibbl, comment.$key);
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/comments/comments.component.ts